import axios from 'axios';

// Use /api for all environments - proxy handles dev, production backend URL or Netlify functions handle production
// For production with separate backend (Hostinger), set REACT_APP_API_URL in .env.production
const API = process.env.REACT_APP_API_URL || '/api';

// Create axios instance
const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('ad_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('ad_token');
      localStorage.removeItem('ad_user');
      if (window.location.pathname.startsWith('/admin') && window.location.pathname !== '/admin/login') {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(error);
  }
);

// Auth
export const login = (data) => api.post('/auth/login', data);
export const getMe = () => api.get('/auth/me');
export const changePassword = (data) => api.put('/auth/password', data);
export const updateProfile = (data) => api.put('/auth/profile', data);

// Public Services
export const getServices = () => api.get('/services');
export const getServiceBySlug = (slug) => api.get(`/services/${slug}`);

// Public FAQs
export const getFAQs = () => api.get('/faqs');

// Public Settings
export const getSettings = () => api.get('/settings');

// Public Social Media
export const getSocialMedia = () => api.get('/social-media');

// Create Lead (Contact Form)
export const createLead = (data) => api.post('/leads', data);

// Image Upload
export const uploadImage = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
export const getImageUrl = (imageId) => `/api/images/${imageId}`;
export const adminGetImages = () => api.get('/admin/images');
export const adminDeleteImage = (id) => api.delete(`/admin/images/${id}`);

// Admin Services
export const adminGetServices = () => api.get('/admin/services');
export const adminCreateService = (data) => api.post('/admin/services', data);
export const adminUpdateService = (id, data) => api.put(`/admin/services/${id}`, data);
export const adminDeleteService = (id) => api.delete(`/admin/services/${id}`);

// Admin FAQs
export const adminGetFAQs = () => api.get('/admin/faqs');
export const adminCreateFAQ = (data) => api.post('/admin/faqs', data);
export const adminUpdateFAQ = (id, data) => api.put(`/admin/faqs/${id}`, data);
export const adminDeleteFAQ = (id) => api.delete(`/admin/faqs/${id}`);

// Admin Leads
export const adminGetLeads = () => api.get('/admin/leads');
export const adminUpdateLeadStatus = (id, status) => api.put(`/admin/leads/${id}/status?status=${status}`);
export const adminDeleteLead = (id) => api.delete(`/admin/leads/${id}`);

// Admin Settings
export const adminGetSettings = () => api.get('/admin/settings');
export const adminUpdateSettings = (settings) => api.put('/admin/settings', settings);

// Admin Social Media
export const adminGetSocialMedia = () => api.get('/admin/social-media');
export const adminCreateSocialMedia = (data) => api.post('/admin/social-media', data);
export const adminUpdateSocialMedia = (id, data) => api.put(`/admin/social-media/${id}`, data);
export const adminDeleteSocialMedia = (id) => api.delete(`/admin/social-media/${id}`);

// Admin Stats
export const adminGetStats = () => api.get('/admin/stats');

// Seed Database
export const seedDatabase = () => api.post('/seed');

export default api;
